import json from './sprite.js';

export default {
    handle: 'SP_SPT5-Birthday',
    label: 'es_SPT5-Birthday_234684168',
    json,
};
